<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>查理宝支付宝流水管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="订单号"
                        prop="out_trade_no">
            <el-input placeholder="请输入订单号"
                      v-model="search.out_trade_no"></el-input>
          </el-form-item>
          <el-form-item label="交易流水号"
                        prop="trade_no">
            <el-input placeholder="请输入交易流水号"
                      v-model="search.trade_no"></el-input>
          </el-form-item>
          <el-form-item label="交易状态"
                        prop="trade_status">
            <el-select v-model="search.trade_status"
                       clearable
                       placeholder="请输入交易状态"
                       class="width-max">
              <el-option
                v-for="(label, value) in tradeStatus"
                :key="value"
                :label="label"
                :value="value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交易付款时间"
                        prop="gmt_payment">
            <el-date-picker
              v-model="search.gmt_payment"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              :picker-options="dateTimePickerRangeOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="充值客户"
                        prop="customerid">
            <sj-remote-select v-model="search.customerid"
                              :remote-method="getCustomerTable"
                              :remote-params="{type:20}"
                              style="width: 100%;"></sj-remote-select>
          </el-form-item>
          <el-form-item label="充值用户"
                        prop="userid">
            <sj-remote-select v-model="search.userid"
                              keyword-key="name"
                              :remote-method="getPlatformUsersIndex"
                              style="width: 100%;"></sj-remote-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="out_trade_no"
                         label="订单号"></el-table-column>
        <el-table-column prop="trade_no"
                         label="交易流水号"></el-table-column>
        <el-table-column prop="subject"
                         label="商品名称"></el-table-column>
        <el-table-column prop="trade_status"
                         label="交易状态"
                         width="90"
                         :formatter="(row) => tradeStatus[row.trade_status]"></el-table-column>
        <el-table-column prop="gmt_create"
                         label="交易创建时间"
                         width="162"
                         :formatter="(row) => formatDate(row.gmt_create * 1000)"></el-table-column>
        <el-table-column prop="gmt_payment"
                         label="交易付款时间"
                         width="162"
                         :formatter="(row) => row.gmt_payment ? formatDate(row.gmt_payment * 1000) : '-'"></el-table-column>
        <el-table-column prop="total_fee"
                         label="交易金额"
                         width="90"></el-table-column>
        <el-table-column prop="admin_user.name"
                         label="充值用户"
                         width="90"></el-table-column>
        <el-table-column prop="customer.name"
                         label="充值客户"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../clb-alipay-flow.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        out_trade_no: null,
        trade_no: null,
        trade_status: null,
        gmt_payment: [],
        customerid: null,
        userid: null,
      },
      searchFieldType: {
        userid: Number
      },
      exportHeader: [
        {
          key: 'id',
          text: '查理宝支付宝流水ID',
        },
        {
          key: 'name',
          text: '查理宝支付宝流水名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({
    tradeStatus: state => state.clbAlipayFlow.tradeStatus,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions(['getCustomerTable', 'getPlatformUsersIndex']),
    ...request.map([]),
    formatDate: filter.formatDate,
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getClbAlipayFlowTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportClbAlipayFlowData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteClbAlipayFlowData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/clb-alipay-flow/pages/ClbAlipayFlowTable.vue